import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { BtnConfig, MiniBtnConfig } from '../../model';

/**
 * * Componente de Cabeçalho para o Apolo.
 */
@Component({
  selector: 'ui-generic-heading',
  templateUrl: './generic-heading.component.html',
  styleUrls: ['./generic-heading.component.scss']
})
export class GenericHeadingComponent implements OnInit {

  /**
   * * Título do cabeçalho.
   */
  @Input() public title!: string;

  /**
   * * Classe do ícone a ser exibido ao lado do título.
   */
  @Input() public icon!: string;

  /**
   * * Indica se o componente é um título de um modal.
   */
  @Input() public modal: boolean = false;

  /**
   * * Renderizar (ou não) botão de fechar.
   */
  @Input() public closeBtn: boolean = false; // 'true' or 'false'

  /**
   * * Evento a ser chamado pelo botão de fechar.
   */
  @Output() onclose: EventEmitter<boolean> = new EventEmitter();

  /**
   * * Renderizar (ou não) botão de minimizar.
   */
  @Input() public minimizeBtn: boolean = false; // 'true' or 'false'

  /**
   * * Evento a ser chamado pelo botão de minimizar.
   */
  @Output() onminimize: EventEmitter<boolean> = new EventEmitter();

  /**
   * * Configuração do Botão Extra.
   */
  @Input() public hBtnConfig!: BtnConfig;

  /**
   * * Configuração do Botão Extra (Mini).
   */
  @Input() public miniBtnConfig!: MiniBtnConfig;

  /**
   * * Evento de Clique para o botão extra.
   */
  @Output() onHBtnClick = new EventEmitter<any>();

  /**
   * * Evento de Clique para o botão extra (mini).
   */
  @Output() onMiniBtnClick = new EventEmitter<any>();

  /**
   * * Template customizado para os botões do header,
   * * que será controlado pelo componente pai.
   */
  @Input() customButtonsTemplate!: TemplateRef<any>;
  

  constructor() { }

  ngOnInit(): void {
  }

  close(): void {
    this.onclose.emit(true);
  }

  minimize(): void {
    this.onminimize.emit(true);
  }

  emit(event: any) { 
    this.onHBtnClick.emit(event);
  }

  emitMini(event: any) { 
    this.onMiniBtnClick.emit(event);
  }

}

